import { Button } from '@/components/Button/Button';

import styles from './ChatErrorBanner.module.css';

interface ChatErrorBannerProps {
  error: string;
  onDismiss: () => void;
}

export function ChatErrorBanner({ error, onDismiss }: ChatErrorBannerProps) {
  return (
    <div className={styles.banner} role="alert">
      <p className={styles.message}>{error}</p>
      <Button onClick={onDismiss} size="small" variant="ghost">
        Dismiss
      </Button>
    </div>
  );
}
